var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-icons"},[_c('img',{attrs:{"src":require("@/assets/img/fb.png"),"alt":"facebook-icon"}}),_c('img',{attrs:{"src":require("@/assets/img/ln.png"),"alt":"linkedin-icon"}}),_c('img',{attrs:{"src":require("@/assets/img/tw.png"),"alt":"twitter-icon"}})])
}]

export { render, staticRenderFns }